// extracted by mini-css-extract-plugin
module.exports = {"header":"header--ZcZYI_c6sX","small":"small--Eb1aruMTR2"};